<template>
  <div>
    <!-- 切换身份 -->
    <a-modal
      :title="$t('main.change_identity' )"
      :destroyOnClose="true"
      :keyboard="false"
      :maskClosable="false"
      :closable="false"
      v-model="modelVisible"
      @cancel="onCancel"
      @ok="handleChange"
    >
      <a-form-model
        ref="form"
        :colon="false"
        :hideRequiredMark="true"
        :model="form"
      >
        <a-form-model-item v-bind="formItemLayout">
          <div slot="label" class="label_box">
            <div class="label_require">&nbsp;&nbsp;</div>
            <div class="slot_form_label">{{ $t("search.hospital") }}</div>
            <div class="label_colon">:</div>
          </div>
          <a-select
            :placeholder="$t('search.hospital_placeholder')"
            v-model="form.higherHospitalUuid"
            @change="itemChange"
            style="width: 100%"
          >
            <a-select-option
              v-for="(item, index) in hospitalList"
              :key="index"
              :value="item.uuid"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
const formItemLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 }
}

export default {
  props: {},
  data () {
    return {
      formItemLayout,
      loading: false,
      hospitalList: [],
      modelVisible: false,
      form: {},
      hospitalUuid: ''
    }
  },
  computed: {},
  mounted () {

  },
  methods: {
    onCancel () {
      this.form = {}
      this.modelVisible = false
    },
    handleChange () {
      this.setHospital(this.hospitalUuid)
      this.onCancel()
      setTimeout(() => {
        this.$message.success(this.$t('normal.operation_succeeded'))
        location.reload()
      }, 500)
    },
    itemChange (e) {
      this.form.higherHospitalUuid = e
      this.hospitalUuid = e
      this.$forceUpdate()
    },
    getHospitalList (params = {}) {
      this.loading = true
      params.pageSize = 9999
      params.pageNum = 1
      this.$post('web/hospital/selectMyList', params).then((r) => {
        let data = r.data
        if (data.code === 200) {
          this.hospitalList = data.data.list || []
          this.loading = false
        } else {
          this.loading = false
        }
      })
    },
    ...mapMutations({
      setHospital: 'account/setHospital'
    })
  }
}
</script>
<style lang="less">
</style>



// WEBPACK FOOTER //
// src/views/common/SwitchIdentities.vue